import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';
import { getPhone } from './getPhone';

export const getCallSettings = ({ callNumber }: Partial<ChatsChannelBase>) => {
  if (!callNumber) return null;

  const url = `tel:${getPhone(callNumber)}`;

  return {
    provider: ChatsChannelType.call,
    title: 'Call',
    link: { url, options: { openCurrentPage: true } },
    icon: getChatIcon(ChatsChannelType.call),
    color: 'rgb(1, 214, 19)'
  } as ChatsChannelSetting;
};
